exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cube-popup-center .cube-popup-content{\n  border-radius: 2.66667vw !important;\n}\n.cube-picker-wheel-item,.cube-action-sheet-item{\n  font-size: 3.73333vw !important;\n  font-family: PingFang SC;\n  font-weight: 400;\n  color: #333333;\n}\n", ""]);

// exports
